import React from 'react';
import { SearchInput, Select, Button } from '@/components/ui';
import type { ReworkFilters, ReworkStatus } from '../types/construction-rework.types';

interface Props {
  filters: ReworkFilters;
  onFilterChange: (filters: ReworkFilters) => void;
  onAdd: () => void;
}

export const ReworkToolbar: React.FC<Props> = ({ filters, onFilterChange, onAdd }) => {
  return (
    <div className="flex flex-col md:flex-row gap-4 mb-6 items-center justify-between bg-white p-4 rounded-2xl border border-slate-100 shadow-sm">
      <div className="flex flex-1 gap-4 w-full md:w-auto">
        <SearchInput
          placeholder="Tìm mã lệnh, nội dung..."
          value={filters.search}
          onChange={(val) => onFilterChange({ ...filters, search: val })}
          className="max-w-xs"
        />
        <Select
          value={filters.status}
          onValueChange={(val) => onFilterChange({ ...filters, status: val as ReworkStatus | 'all' })}
          options={[
            { value: 'all', label: 'Tất cả trạng thái' },
            { value: 'assigned', label: 'Đã giao việc' },
            { value: 'in_progress', label: 'Đang sửa' },
            { value: 'completed', label: 'Hoàn thành' },
          ]}
          className="w-48"
        />
      </div>
      
      <div className="flex gap-2 w-full md:w-auto">
        <Button variant="outline" icon="ri-download-line">Xuất báo cáo</Button>
        <Button variant="primary" icon="ri-add-line" onClick={onAdd}>Tạo lệnh sửa lỗi</Button>
      </div>
    </div>
  );
};
